import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function AddPairIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14.004"}
      height={height || "14.004"}
      viewBox="0 0 14.004 14.004"
    >
      <path
        id="Add"
        d="M5.8,13.988,5.749,8.2H.016L0,5.674H5.726L5.674,0,8.2.016l.053,5.658h5.734L14,8.2H8.277L8.33,14Z"
        fill={color || "#75b85c"}
      />
    </svg>
  );
}
